/** @jsxImportSource theme-ui */
import { Link } from 'react-router-dom'

export const Breadcrumbs = ({ data }) => (
  <div
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      my: 48,
      alignItems: 'center',
    }}
  >
    <div
      sx={{
        width: '100%',
        mb: 20,
        textAlign: 'center',
        variant: 'links.breadcrumbs',
        ':hover': { textDecoration: 'none' },
      }}
    >
      <Link to="/" sx={{ variant: 'links.breadcrumbs' }}>
        Gallery Walls
      </Link>
      {data && (
        <>
          &nbsp;/&nbsp;
          <Link to={`/layout/${data.data.id}`} sx={{ variant: 'links.breadcrumbs' }}>
            {data.data.title}
          </Link>
        </>
      )}
    </div>
    <h2 sx={{ fontFamily: 'heading', fontSize: '2.188rem' }}>Gallery Walls</h2>
  </div>
)
